import { useMemo } from 'react';
import { TeamInsuranceProduct } from 'types';

export function useGetInsuranceProductsFromTeamProducts(teamProducts: TeamInsuranceProduct[]) {
  return useMemo(() => teamProducts.map((teamProduct) => teamProduct.insuranceProduct), [teamProducts]); // You should depend on `teamProducts` here if you want to recompute when the teamProducts change
}
